import React, { useEffect, useState } from "react";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { NavLink, useHistory } from "react-router-dom";
import clsx from "clsx";
import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import styles from "./PrivateMenu.module.scss";
import { getUsername, signOut, isCBUser, IsCommercialHorizon, getCompanyId, getUserId, getUserRole, isMegatronFeatureOn, isMegatronLiteUser, isMegatronProUser, isMegatronCompanyUser, getRoleLabel, isBRCGSUser, isCBCommercialHorizonUser } from "../../Authentication/Auth";
import { AuditUrls } from "../../views/AuditManagement";
import { VerifyUrls } from "../../views/VerifyManagement";
import { AuditorUrls } from "../../views/AuditorManagement";
import { CompanyUrls } from "../../views/CompanyManagement";
import { CBUrls } from "../../views/CBManagement";
import { UserUrls } from "../../views/UserManagement";
import { isCompanyUser} from "../../Authentication/Auth";
import {
  PATH_ADMINISTRATION,
  PATH_DASHBOARDS,
  PATH_NOTIFICATION_MANAGEMENT,
  PATH_REPORT_MANAGEMENT,
  PATH_IFS_REPORT_MANAGEMENT,
  raiseQuery,
  raiseQueryCompanyUser,
  privateArea,
} from "../Paths/paths";
import TextButton from "../TextButton";
import { useUserPermission } from "../../routing/contexts/PermissionContext";
import PermissionArea from "../../Authentication/model/PermissionArea";
import { Permission } from "../../Authentication/model/Permission";
import { RecallUrls } from "../../views/RecallManagement";
import { dispatch } from "../App/App";
import { clearTableInputs } from "../../store/details/actions/getTableFilterInputs";
import PDFTooltip from "../Tooltips/pdfToolTip";
import { upgradeToProText } from "../../constants/ToolTipsText";
import MegatronProLogo from '../../assets/DirectoryProIcon.png';
import MegatronLiteLogo from '../../assets/DirectoryLiteIcon.png';
import MegatronPlainLogo from '../../assets/DirectoryPlainLogo.png'
import useMegatron from "../../hooks/useMegatron";
import { trackEvent } from "../../util/googletagmanager/GTM";
interface NavigationLink {
  readonly link: string;
  readonly text: string;
  readonly permissionTargets: PermissionArea[];
  readonly separated?: boolean;
  readonly route?: string; // add route property as optional
}

const usualMenuItems: NavigationLink[] = [
  {
    link: "",
    text: "Tools",
    permissionTargets: [],
  },
  {
    link: AuditUrls.searchTable,
    text: "Audits",
    permissionTargets: [PermissionArea.AUDIT],
  },
  {
    link: VerifyUrls.searchTable,
    text: "Certificate Tracker",
    permissionTargets: [PermissionArea.VERIFY]
  },
  {
    link: AuditorUrls.searchTable,
    text: "Auditors",
    permissionTargets: [PermissionArea.AUDITOR],
  },
  {
    link: CompanyUrls.searchTable,
    text: "Companies",
    permissionTargets: [PermissionArea.COMPANY],
  },
  {
    link: RecallUrls.searchTable,
    text: "Recalls",
    permissionTargets: [PermissionArea.RECALL],
  },
  {
    link: CBUrls.searchTable,
    text: "Certification Bodies",
    permissionTargets: [PermissionArea.CB, PermissionArea.SUB_OFFICE],
  },
  {
    link: UserUrls.searchTable,
    text: "Users",
    permissionTargets: [PermissionArea.USER],
  },
  {
    link: PATH_REPORT_MANAGEMENT,
    text: "Reports",
    permissionTargets: [PermissionArea.REPORT],
  },
  {
    link: PATH_NOTIFICATION_MANAGEMENT,
    text: "Notifications",
    permissionTargets: [],
  },
  {
    link: "",
    route: raiseQuery,
    text: "Raise a Query",
    permissionTargets: [PermissionArea.CB],
  },
  {
    link: "",
    route: raiseQueryCompanyUser, //isCompanyUser() == true? raiseQueryCompanyUser :raiseQuery,
    text: "Assistance",
    permissionTargets: [PermissionArea.COMPANY],
  },
  {
    link: PATH_DASHBOARDS,
    text: "Analytics",
    permissionTargets: [PermissionArea.ANALYTIC],
  },
  {
    link: PATH_IFS_REPORT_MANAGEMENT,
    text: "IFS Audit Report",
    permissionTargets: [PermissionArea.IFS],
  },
  {
    link: PATH_ADMINISTRATION,
    text: "Administration",
    permissionTargets: [PermissionArea.ADMINISTRATION],
    separated: true,
  },
];

//megatron menu
const megatronMenuItems: NavigationLink[] = [
  {
    link: "",
    text: "Tools",
    permissionTargets: [],
  },
  {
    link: VerifyUrls.searchTable,
    text: "Certificate Tracker",
    permissionTargets: [PermissionArea.VERIFY]
  },
  {
    link: AuditUrls.searchTable,
    text: "My Audits",
    permissionTargets: [PermissionArea.AUDIT],
  },
  {
    link: PATH_DASHBOARDS,
    text: "Analytics",
    permissionTargets: [PermissionArea.ANALYTIC],
  },
  {
    link: PATH_REPORT_MANAGEMENT,
    text: "Reporting",
    permissionTargets: [PermissionArea.REPORT],
  }, 
  {
    link: "",
    route: raiseQueryCompanyUser, //isCompanyUser() == true? raiseQueryCompanyUser :raiseQuery,
    text: "Assistance",
    permissionTargets: [PermissionArea.COMPANY],
  },   
  {
    link: "",    
    text: "Admin Centre",
    permissionTargets: [],
  },
  {
    link: CompanyUrls.searchTable,
    text: "My Company",
    permissionTargets: [PermissionArea.COMPANY],
  },
  {
    link: UserUrls.searchTable,
    text: "Add Users",
    permissionTargets: [PermissionArea.USER],
  }, 
  {
    link: PATH_NOTIFICATION_MANAGEMENT,
    text: "Notifications",
    permissionTargets: [],
  },
  {
    link: AuditorUrls.searchTable,
    text: "Auditors",
    permissionTargets: [PermissionArea.AUDITOR],
  }, 
  {
    link: RecallUrls.searchTable,
    text: "Recalls",
    permissionTargets: [PermissionArea.RECALL],
  },
  {
    link: CBUrls.searchTable,
    text: "Certification Bodies",
    permissionTargets: [PermissionArea.CB, PermissionArea.SUB_OFFICE],
  },
  {
    link: "",
    route: raiseQuery,
    text: "Raise a Query",
    permissionTargets: [PermissionArea.CB],
  },  
  {
    link: PATH_IFS_REPORT_MANAGEMENT,
    text: "IFS Audit Report",
    permissionTargets: [PermissionArea.IFS],
  },
  {
    link: PATH_ADMINISTRATION,
    text: "Administration",
    permissionTargets: [PermissionArea.ADMINISTRATION],
    separated: true,
  },
];

const megatronLiteUserMenuItems: NavigationLink[] = [
  {
    link: "",
    text: "Tools",
    permissionTargets: [],
  },
  {
    link: VerifyUrls.searchTable,
    text: "Certificate Tracker",
    permissionTargets: [PermissionArea.VERIFY]
  },   
  {
    link: "",
    route: raiseQueryCompanyUser, //isCompanyUser() == true? raiseQueryCompanyUser :raiseQuery,
    text: "Assistance",
    permissionTargets: [PermissionArea.COMPANY],
  },   
  {
    link: "",    
    text: "Admin Centre",
    permissionTargets: [],
  },
  {
    link: CompanyUrls.searchTable,
    text: "My Company",
    permissionTargets: [PermissionArea.COMPANY],
  },
  {
    link: UserUrls.searchTable,
    text: "Add Users",
    permissionTargets: [PermissionArea.USER],
  }, 
  {
    link: PATH_NOTIFICATION_MANAGEMENT,
    text: "Notifications",
    permissionTargets: [PermissionArea.COMPANY],
  }
];

 const PrivateMenu = () => {
  // const [isMegatronFetaureOn, setisMegatronFetaureOn] = useState<boolean>(false);
  
    // const fetchisMegatronFetaureOn = async () => {
    //   const megatronFeature = await isMegatronFeatureOn();
    //   setisMegatronFetaureOn(megatronFeature);
    // };
    // fetchisMegatronFetaureOn();

    // const megatronUser = getUserId() != undefined && isMegatronCompanyUser() && isMegatronFetaureOn;//&& isMegatronFeatureOn();
    // const megatronLiteUser = getUserId() != undefined && isMegatronLiteUser() && isMegatronFetaureOn;
    // const megatronProUser = getUserId() != undefined && isMegatronProUser() && isMegatronFetaureOn;
    const {megatronLiteUser, megatronProUser, isMegatronFeaturedOn: isMegatronFetaureOn, isLoading, megatronUser}= useMegatron();
    const menuItems = megatronUser ? (megatronLiteUser ? megatronLiteUserMenuItems : megatronMenuItems) : usualMenuItems;
    const brcgsUser = getUserId() != undefined && isBRCGSUser() && isMegatronFetaureOn;
    const cbUser = getUserId() != undefined && isCBUser() && isMegatronFetaureOn;
    
    const [isOpen, setOpen] = useState(true);
    const userPermission = useUserPermission();
    const history = useHistory();
    
    const hasPermission = (permissionTargets: PermissionArea[]) =>
      permissionTargets.length === 0 ||
    permissionTargets.some((permissionTarget) =>
      userPermission[permissionTarget]?.some(
        (permission) => permission === Permission.VIEW
      )
    );

    //Handling Both Hover/Click
    const handleLiteUserNotificationsMenuClick = (
      event: React.MouseEvent<HTMLAnchorElement>
    ) => {
      trackEvent('Feature_Interaction',{
                  User_Role:"Company user Lite",
                  Tab_Section:"Notifications",
                  Type:"Button/Hover message",
                  Feature_Function:"Notifications tab - Pro feature (blocked)",
                  UserInput:"Click/Hover"});
      if(event.type=="click")
      {
        event.preventDefault();
      }
    };

    const handleRaiseQueryClick = (
      event: React.MouseEvent<HTMLAnchorElement>
    ) => {
      trackEvent('Feature_Interaction',{
        User_Role:"Company user Pro",
        Tab_Section:"Assistance tab",
        Type:"Button",
        Feature_Function:"Raise a new query in JotForm (External Link)",
        UserInput:"Click"});
    event.preventDefault();
    window.open(isCompanyUser() == true ? raiseQueryCompanyUser : raiseQuery, "_blank");
  };
  
  const clearVerifyRedux = (text?: string) => {
    if(text!="Certificate Tracker") 
      dispatch(clearTableInputs())
  };

  const companyUser=isCompanyUser();
  let propertyValue="";
  if(companyUser==true)
  {
    propertyValue=getCompanyId();
  }

  useEffect(() => {
    if (!isLoading) {
      if (window.location.pathname === "/private") {
        if (megatronProUser || megatronLiteUser || IsCommercialHorizon())
          history.push(`${privateArea}/verify`);
        else history.push(`${privateArea}/audit`);
      }
      return;
    }
  }, [megatronLiteUser, megatronProUser]);
  
  
  
  // if(companyUser==true)
  // {
  // const primaryOrg=getUserPrimaryOrg();
  // const jsonData=JSON.parse(primaryOrg);
  
  // let propertyNameCo = "co"
  // let propertyNameCb="cb"
  // let propertyNamea = "a"
  // let propertyNameo="o";
  // let propertyNames="s";
  
  // if( jsonData[propertyNameCo].length==1)
  // {
  //   propertyValue= jsonData[propertyNameCo];
  // }
  // else if(jsonData[propertyNameCb].length==1)
  // {
  //   propertyValue= jsonData[propertyNameCb];
  // }
  // else if(jsonData[propertyNamea].length==1)
  // {
  //   propertyValue= jsonData[propertyNamea];
  // }
  // else if(jsonData[propertyNameo].length==1)
  // {
  //   propertyValue= jsonData[propertyNameo];
  // }
  // else if(jsonData[propertyNames].length==1)
  // {
  //   propertyValue= jsonData[propertyNames];
  // }
  // }
  // logs a JavaScript object, not a string
  
  
  return (
    <>
      <div className={clsx(styles.menuSpacing, { [styles.open]: isOpen })} />
      <nav
        className={clsx(styles.menu, styles.menuSpacing, {
          [styles.open]: isOpen,
          [styles.gradientBackground]: brcgsUser || cbUser || megatronUser || IsCommercialHorizon()
        })}
      >
        <IconButton
          onClick={() => setOpen((prev) => !prev)}
          className={styles.toggleButton}
        >
          {isOpen ? <CloseIcon /> : <MenuIcon />}
        </IconButton>

        <div className={styles.content}>
          {!megatronUser && <h1>BRCGS</h1>}
          <div>
             {megatronProUser ? (
              <img src={MegatronProLogo} className={styles.megatronDirectoryImage}/>
            ) : megatronLiteUser ? (
              <img src={MegatronLiteLogo} className={styles.megatronDirectoryImage}/>) :
              (<img src={MegatronPlainLogo} className={styles.megatronDirectoryImage}/>)}
          </div>
          <div className={styles.account}>
            {!megatronUser && <AccountCircleIcon />}
            {megatronUser && <div className={styles.megatronEmptyDiv}></div>}
            <b>{!megatronUser ? getUsername() : ""}</b>
            {companyUser == true && (
              <span className={megatronUser ? styles.megatronLeftAlign : ""}>
                <b>Company ID: {propertyValue}</b>
              </span>
            )}
            <span className={megatronUser ? styles.megatronLeftAlign : ""}>
              <b>{megatronUser ? getRoleLabel(getUserRole()) : ""}</b>
            </span>
            {!megatronUser && (
              <TextButton onClick={signOut}>Sign out</TextButton>
            )}
          </div>
          {menuItems
            .filter((item) => hasPermission(item.permissionTargets))
            .map((item) => {
              if (item.text === "Notifications" && IsCommercialHorizon()) {
                return null;
              }
              if(item.text === "Tools" && !isMegatronFetaureOn) {
                  return null;
              }
              if (item.text === "Notifications" && megatronLiteUser) {
                return (
                  <PDFTooltip title={upgradeToProText}>
                    <NavLink
                      to=""
                      isActive={() => false}
                      onClick={handleLiteUserNotificationsMenuClick}
                      onMouseLeave={handleLiteUserNotificationsMenuClick}
                      className={clsx(
                        styles.link,
                        megatronUser ? styles.megatronMenuLinks : "",
                        {
                          [styles.separated]: item.separated,
                        }
                      )}
                      activeClassName={styles.activeLink}
                      style={{ cursor: "not-allowed" }}
                    >
                      {item.text}
                    </NavLink>
                  </PDFTooltip>
                );
              }
              if (item.route) {
                if (item.text === "Raise a Query" && !isCBUser()) {
                  return null;
                }
                if (item.text === "Assistance" && !isCompanyUser()) {
                  return null;
                }
                // check if the item has a route property
                // render the "Raise a Query" link as an anchor tag with an onClick event handler
                const target =
                  item.text === "Raise a Query" || item.text === "Assistance"
                    ? "_blank"
                    : undefined;
                return (
                  <a
                    href={item.route}
                    key={item.text}
                    className={clsx(
                      styles.link,
                      item.text === "Assistance"
                        ? megatronUser
                          ? styles.megatronMenuAssistance
                          : ""
                        : "",
                      {
                        [styles.separated]: item.separated,
                      }
                    )}
                    onClick={
                      item.text === "Raise a Query" ||
                      item.text === "Assistance"
                        ? handleRaiseQueryClick
                        : undefined
                    }
                    target={target}
                    rel={
                      target === "_blank" ? "noopener noreferrer" : undefined
                    }
                  >
                    {item.text}
                  </a>
                );
              }
              // render other links as NavLink components
              return (megatronUser || cbUser || brcgsUser || IsCommercialHorizon()) && (item.link === "" && item.permissionTargets.length === 0) ? (
                <label
                  key={item.text}
                  className={clsx(styles.linkLabel, styles.megatronMenuLabels, {
                    [styles.separated]: item.separated,
                  })}
                >
                  {item.text} 
                </label>
              ) : (
                <NavLink
                  onClick={() => clearVerifyRedux(item.text)}
                  to={item.link}
                  key={item.text}
                  className={clsx(
                    styles.link,
                    (megatronUser || cbUser || brcgsUser || IsCommercialHorizon()) ? styles.megatronMenuLinks : "",
                    {
                      [styles.separated]: item.separated,
                    }
                  )}
                  activeClassName={styles.activeLink}
                >
                  {item.text}
                </NavLink>
              );
            })}
          <div className={megatronUser ? styles.megatronAccount : ""}>
            {megatronUser ? getUsername() : ""}
            {megatronUser && (
              <TextButton onClick={signOut}>Sign out</TextButton>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default PrivateMenu;
